import type { SVGProps } from 'react';
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 20L12 0L24 20H0ZM2.22575 18.75H21.7743L12 2.5L2.22575 18.75ZM12 17.0194C12.2257 17.0194 12.4149 16.9456 12.5677 16.7981C12.7204 16.6506 12.7968 16.4679 12.7968 16.25C12.7968 16.0321 12.7204 15.8494 12.5677 15.7019C12.4149 15.5544 12.2257 15.4806 12 15.4806C11.7743 15.4806 11.5851 15.5544 11.4323 15.7019C11.2796 15.8494 11.2032 16.0321 11.2032 16.25C11.2032 16.4679 11.2796 16.6506 11.4323 16.7981C11.5851 16.9456 11.7743 17.0194 12 17.0194ZM11.3527 14.2306H12.6473V7.98063H11.3527V14.2306Z"
      fill="#E22828"
    />
  </svg>
);
export default SvgWarning;
 
 